import jp2 from './ready-to-serve.jp2';
import png from './ready-to-serve.png';
import webp from './ready-to-serve.webp';

export const readyToServe = [webp, jp2, png];
